module.exports = __webpack_public_path__ + "static/media/brou.3f60b218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brou.png
// module id = 485
// module chunks = 0 1 2